import React, {useState, useEffect} from 'react'
import {Row, Col, Button, Card, Form, Input, Select, message} from 'antd'
import Layouts from '../components/Layouts'
import apiRequest from '../hooks/ApiRequest'

const {TextArea} = Input
const {Option} = Select

const EsclateSystem = props => {
  const {form} = props
  const {getFieldDecorator, validateFields, resetFields} = form
  const [insurers, setInsurers] = useState([])
  const brokerId = localStorage.getItem('loggedInUserID')
  useEffect(() => {
    const fetchInsurers = async () => {
      try {
        let combinedList = []

        const res = await apiRequest(
          process.env.REACT_APP_BASE_URL_AUTH +
            '/api/Auth/GetInsurersAndUnderwritterByBrokerId',
          //   'https://localhost:7260/api/Auth/GetInsurersAndUnderwritterByBrokerId',
          'POST',
          [brokerId],
        )

        if (res?.data?.underwriters || res?.data?.insurers) {
          // Combine both lists and tag with their role
          const underwriterAndInsurerList = [
            ...(res?.data?.insurers || []).map(person => ({
              id: person.id,
              name: `${person.firstName} ${person.lastName}`,
              email: person.email,
              role: 'Insurer',
            })),
            ...(res?.data?.underwriters || []).map(person => ({
              id: person.id,
              name: `${person.firstName} ${person.lastName}`,
              email: person.email,
              role: 'Underwriter',
            })),
          ]

          combinedList = [...combinedList, ...underwriterAndInsurerList]
        }

        const res2 = await apiRequest(
          process.env.REACT_APP_BASE_URL +
            '/Policy/GetCustomersByBrokerId/GetCustomersByBrokerId',
          'POST',
          [brokerId],
        )

        if (res2?.data?.customerEmails) {
          const customerEmailList = res2.data.customerEmails.map(
            item => item.customeremail,
          )

          const res3 = await apiRequest(
            process.env.REACT_APP_BASE_URL_AUTH +
              '/api/Auth/GetCustomerByCustomerEmails',
            'POST',
            customerEmailList,
          )

          if (res3?.data?.customers) {
            const customerList = res3.data.customers.map(customer => ({
              id: customer.id,
              name: `${customer.firstName} ${customer.lastName}`,
              email: customer.email,
              role: 'Customer',
            }))

            combinedList = [...combinedList, ...customerList]
          }
        }

        setInsurers(combinedList)
      } catch (error) {
        console.error('Error fetching insurer list:', error)
      }
    }

    fetchInsurers()
  }, [])
  console.log(JSON.parse(localStorage.getItem('user'))?.email)

  const handleSubmit = e => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        try {
          const payload = {
            recipientEmails: values.recipients,
            bodyDescription: values.issue,
            senderEmail: JSON.parse(localStorage.getItem('user'))?.email,
          }
          const res = await apiRequest(
            process.env.REACT_APP_BASE_URL_AUTH +
              '/api/Auth/send-email-to-underwritter-Insurer',
            //    'https://localhost:7260/api/Auth/send-email-to-underwritter-Insurer',
            'POST',
            payload,
          )

          if (res.success) {
            message.success('Issue escalated successfully!')
            resetFields()
          } else {
            message.error('Failed to escalate issue.')
          }
        } catch (err) {
          console.error('Escalation error:', err)
          message.error('Something went wrong.')
        }
      }
    })
  }

  return (
    <div title="Escalate Issue" className=" ant-layout-content dashboard">
      <div className="dash-bg-white">
        <Row gutter={16}>
          <Col xs={24} sm={24} md={12}>
          <div className="section-top-heading">
            <h3 style={{color: '#0C1362', fontWeight: '600', fontSize: 20}}>
              Escalate Issues
            </h3>
          </div>
          </Col>
        </Row>
      </div>
      <div className="dash-bg-white">
        <Card title="Escalate Issue to Insurer or UnderWriter" bordered={false}>
          <Form layout="vertical" onSubmit={handleSubmit}>
            <Row gutter={16}>
              <Col md={12}>
                <Form.Item label="Select Recipients">
                  {getFieldDecorator('recipients', {
                    rules: [
                      {
                        required: true,
                        message: 'Please select at least one recipient',
                      },
                    ],
                  })(
                    <Select
                      mode="multiple"
                      placeholder="Choose one or more recipients"
                      allowClear>
                      {insurers.map(person => (
                        <Option key={person.id} value={person.email}>
                          {person.name} ({person.role})
                        </Option>
                      ))}
                    </Select>,
                  )}
                </Form.Item>
              </Col>
              <Col md={24}>
                <Form.Item label="Describe the Issue">
                  {getFieldDecorator('issue', {
                    rules: [
                      {required: true, message: 'Please describe the issue'},
                    ],
                  })(
                    <TextArea
                      rows={5}
                      placeholder="Write the issue in detail..."
                    />,
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form>
        </Card>
      </div>
    </div>
  )
}

export default Form.create()(EsclateSystem)
